import { combineReducers } from "redux"
import task from "./task"

export default combineReducers({
  task
})
